export default __webpack_public_path__ + "static/media/img-slider-lh-career-4.3a57260a.png";